// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #121212; /* A deep, neutral dark background */
  color: #e0e0e0; /* A slightly softer white for better readability */
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
  background-color: #2a2a2a;
  padding: 2px 4px;
  border-radius: 4px;
}

/* Indeterminate progress-bar slide for app Start/Stop/Deploying states
   (LandingPage.jsx My Deployments cards). */
@keyframes lyric-progress-slide {
  0%   { transform: translateX(-100%); }
  100% { transform: translateX(250%); }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB,EAAE,oCAAoC;EAC/D,cAAc,EAAE,mDAAmD;AACrE;;AAEA;EACE;aACW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;4CAC4C;AAC5C;EACE,OAAO,4BAA4B,EAAE;EACrC,OAAO,2BAA2B,EAAE;AACtC","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #121212; /* A deep, neutral dark background */\n  color: #e0e0e0; /* A slightly softer white for better readability */\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n  background-color: #2a2a2a;\n  padding: 2px 4px;\n  border-radius: 4px;\n}\n\n/* Indeterminate progress-bar slide for app Start/Stop/Deploying states\n   (LandingPage.jsx My Deployments cards). */\n@keyframes lyric-progress-slide {\n  0%   { transform: translateX(-100%); }\n  100% { transform: translateX(250%); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
